import React from 'react';

/**
 * Reusable Card component
 * @param {string} variant - 'default' | 'glass' | 'solid' | 'interactive'
 * @param {boolean} hover - Whether to show hover effects
 * @param {string} padding - Padding size: 'none' | 'sm' | 'md' | 'lg' | 'xl'
 * @param {string} hoverColor - Hover accent color: 'primary' | 'pink' | 'cyan' | 'gold'
 */
const Card = ({
  children,
  variant = 'default',
  hover = true,
  padding = 'md',
  hoverColor = 'primary',
  className = '',
  ...props
}) => {
  const baseStyles = 'rounded-xl transition-all duration-300 relative overflow-hidden';

  const hoverColors = {
    primary: hover ? 'hover:ring-primary/50 hover:shadow-glow-primary' : '',
    pink: hover ? 'hover:ring-neon-pink/50 hover:shadow-glow-neon' : '',
    cyan: hover ? 'hover:ring-cyan-400/50 hover:shadow-glow-cyan' : '',
    gold: hover ? 'hover:ring-gold/50' : '',
  };

  const variants = {
    default: `
      bg-surface-dark border border-white/5
      ${hover ? `hover:border-${hoverColor === 'primary' ? 'primary' : hoverColor}/30` : ''}
    `,
    glass: `
      bg-white/5 backdrop-blur-md border border-white/10
      ${hover ? 'hover:bg-white/10 hover:border-white/20' : ''}
    `,
    solid: `
      bg-surface-dark
      ${hover ? 'hover:bg-surface-dark/80' : ''}
    `,
    interactive: `
      bg-card-dark ring-1 ring-white/5
      ${hover ? `hover:bg-[#202938] ${hoverColors[hoverColor]}` : ''}
      cursor-pointer
    `,
  };

  const paddings = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
    xl: 'p-8',
  };

  return (
    <div
      className={`
        ${baseStyles}
        ${variants[variant]}
        ${paddings[padding]}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
